import React, { useCallback } from 'react';
import { app_actions } from '../actions/app_actions';
import ConfirmationAndInformationPoup, { POPUP_TYPE } from './UtilityComponents/ConfirmationAndInformationPoup';
import { useDispatch, useSelector } from 'react-redux';
const BuildVersionMismatch = () => {
    const hasVersionMismatch = useSelector((state) => state.ui.versionMismatch);
    const isLoggedIn = useSelector((state) => state.User.isLoggedIn);
    const dispatch = useDispatch();
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfirmationAndInformationPoup, { popupType: POPUP_TYPE.RELOAD, titleText: 'Update Required!', message: `A new version of the application is now available! Please refresh the page to apply the latest updates, or sign out and log back in to continue.`, acceptBtnText: isLoggedIn ? 'Sign Out' : 'Refresh Now', acceptCallBack: useCallback(() => {
                dispatch(app_actions.setVersionMismatch(false));
                dispatch(app_actions.resetStore());
            }, [hasVersionMismatch]), open: hasVersionMismatch, key: `${hasVersionMismatch}` })));
};
export default BuildVersionMismatch;
